import { Component, inject, Input, signal } from '@angular/core';
import { Popup } from "../popup/popup";
import { ModalComponent } from "../modal/modal-component";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { StoragePrefix } from '@core/constant';
import { StorageService } from 'src/app/utils';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-language-modal',
  imports: [ModalComponent, TranslateModule, NgClass],
  templateUrl: './language-modal.component.html',
  styleUrl: './language-modal.component.scss'
})
export class LanguageModalComponent {
  _translate = inject(TranslateService);
  _storage = inject(StorageService);

  @Input() isPopUpVisible = signal(false);
  @Input() currentLang = signal(this._storage.get(StoragePrefix.LANGUAGE || 'en'))


  hideLangModal() {
    this.isPopUpVisible.set(false);
  }
  setLang(lang: any) {
    this.currentLang.set(lang)
  }
  onSelectLang() {
    // const lang = typeof this.currentLang() === 'string' ? this.currentLang() : arg?.target?.value;
    const lang = this.currentLang();
    if (!lang) return;
    this._translate.use(lang);
    document.dir = lang === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
    this._storage.lang.set(lang);
    this._storage.set(StoragePrefix.LANGUAGE, lang);
    this.hideLangModal();
  }
}
